import React, { FC } from 'react';
import { TableOfContents } from '../../../../interfaces/TableOfContents';
import { StyledSafeHtml } from './Content.styles';
import ContentTable from './ContentTable';
import Items from '../../../../components/Items';

export interface ContentProps {
  data: TableOfContents;
  tableOfContentName: string;
}

const Content: FC<ContentProps> = ({ data, tableOfContentName }) => (
  <>
    <StyledSafeHtml>{data.introBody}</StyledSafeHtml>
    <ContentTable data={data} tableOfContentName={tableOfContentName} />
    <Items data={data} />
  </>
);

export default Content;
